<template>
    <v-container fluid fill-height>
        <v-layout flex align-center justify-center v-if="loading">
            <v-flex xs12 class="text-xs-center">
                <v-progress-circular
                indeterminate
                color="primary"
                :size="90"></v-progress-circular>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="!loading">
            <v-flex xs12>
                <h1 class="mt-2 mb-4">Mes rapports</h1>
                <v-list two-line subheader>
                    <v-list-tile v-for="report in reports" :key="report.id" avatar router :to="{ name: 'edit_report', params: { id: report.id }}">
                        <v-list-tile-avatar>
                            <img :src="report.client.logo"/>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ report.client.company_name }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ report.intervention.start_date }}</v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-btn icon>
                                <v-icon color="orange darken-1" v-if="report.state == 'to_sign'">gesture</v-icon>
                                <v-icon color="green accent-4" v-if="report.state == 'signed'">check_circle</v-icon>
                            </v-btn>
                        </v-list-tile-action>
                    </v-list-tile>
                </v-list>
            </v-flex>
        </v-layout>

        <v-snackbar
          top
          color="green accent-4"
          multi-line
          v-model="reportProcessingSuccess">
          L'enregistrement du rapport a été effectué avec succès
        </v-snackbar>
    </v-container>
</template>

<script>
export default {
  props: ['reportProcessingStatus'],
  data () {
    return {
      reportProcessingSuccess: this.reportProcessingStatus === 'success'
    }
  },
  computed: {
    reports () {
      return this.$store.getters.getReports
    },
    loading () {
      return this.$store.getters.loading
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Report/Reports.vue